// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-15453252]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.rich-text-pre[data-v-15453252] {\n  min-height: 64px;\n}\n.rich-text-pre .content[data-v-15453252] {\n  padding: 10px;\n  overflow: hidden;\n  border-radius: 12px;\n}", ""]);
// Exports
module.exports = exports;
